import styled from 'styled-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';
import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

export const EmptyStateWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${rem(spacing.base * 3)};
  gap: ${rem(spacing.base)};
`;

export const HistoryCount = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${toColorString(color.base.alaskanHusky)};
  margin-left: ${rem(spacing.base * 0.5)};
`;

export const LoadMoreWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  padding: ${rem(spacing.base * 1.5)} 0;
  gap: ${rem(spacing.base)};
`;
